export default "__VITE_ASSET__B6EoIR$b__"